import Slider from "./Slider";
import Categories from "./Categories";
import Carousel from 'react-multi-carousel';
import '../assets/css/qualititesSlider.css'

function Qualities() {
    return (
        <>
            <div className="Qualities">
                <div className="Quality">
                    <div className="Q-child">
                        <div className="Q-icon">
                            <i className="fas fa-shipping-fast"></i>
                        </div>
                        <h3 className="Q-title">
                            HOME DELIVERY
                        </h3>
                        <div className="Q-content">
                            At our pharmacy, we recognize the significance of convenience and accessibility in healthcare. Therefore, we take pride in providing a complimentary home delivery service to our esteemed customers.
                        </div>
                    </div>
                    <div className="Q-shade"></div>
                </div>
                <div className="Quality">
                    <div className="Q-child">
                        <div className="Q-icon">
                            <i className="fas fa-box"></i>
                        </div>
                        <h3 className="Q-title">
                            100% PRODUCT
                            AVAILABILITY
                        </h3>
                        <div className="Q-content">
                            We assure our customers that at MD Pharmacy, we uphold a 100% product availability* (*depending on availability from distributor).
                        </div>
                    </div>
                    <div className="Q-shade"></div>
                </div>
                <div className="Quality">
                    <div className="Q-child">
                        <div className="Q-icon">
                            <i className="fas fa-medal"></i>
                        </div>
                        <h3 className="Q-title">
                            100% QUALITY
                            GUARANTEED
                        </h3>
                        <div className="Q-content">
                            At MD Pharmacy, we take pride in delivering excellence, ensuring our customers receive the highest quality products.
                        </div>
                    </div>
                    <div className="Q-shade"></div>
                </div>
            </div>
            <div className="mobile-Qualities">
                <Carousel showDots={true} className="PCarousel"
                    responsive={{
                        desktop: {
                            breakpoint: { max: 3000, min: 1024 },
                            items: 3,
                        },
                        tablet: {
                            breakpoint: { max: 1024, min: 464 },
                            items: 2,
                        },
                        mobile: {
                            breakpoint: { max: 464, min: 0 },
                            items: 1,
                        },
                    }}
                >
                    <div className="Quality">
                        <div className="Q-child">
                            <div className="Q-icon">
                                <i className="fas fa-shipping-fast"></i>
                            </div>
                            <h3 className="Q-title">
                                HOME DELIVERY
                            </h3>
                            <div className="Q-content">
                                At our pharmacy, we recognize the significance of convenience and accessibility in healthcare. Therefore, we take pride in providing a complimentary home delivery service to our esteemed customers.
                            </div>
                        </div>
                    </div>
                    <div className="Quality">
                        <div className="Q-child">
                            <div className="Q-icon">
                                <i className="fas fa-box"></i>
                            </div>
                            <h3 className="Q-title">
                                100% PRODUCT
                                AVAILABILITY
                            </h3>
                            <div className="Q-content">
                                We assure our customers that at MD Pharmacy, we uphold a 100% product availability commitment. We understand the importance of having access to the products you need, when you need them.
                            </div>
                        </div>
                    </div>
                    <div className="Quality">
                        <div className="Q-child">
                            <div className="Q-icon">
                                <i className="fas fa-medal"></i>
                            </div>
                            <h3 className="Q-title">
                                100% QUALITY
                                GUARANTEED
                            </h3>
                            <div className="Q-content">
                                At MD Pharmacy, we take pride in delivering excellence, ensuring our customers receive the highest quality products. Our commitment is simple yet profound: 100% Quality Guaranteed.
                            </div>
                        </div>
                    </div>
                </Carousel>
            </div>
        </>
    )

}

export default Qualities;